import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public loading$ = this._loading.asObservable();
  private _customLoading$: Observable<boolean> | null = null;

  show() {
    this._loading.next(true);
  }

  hide() {
    this._loading.next(false);
  }
  
  overrideLoading(loading$: Observable<boolean>) {
    this._customLoading$ = loading$;
    this.loading$ = loading$;
  }
  
  resetLoading() {
    if (this._customLoading$) {
      this._customLoading$ = null;
      this.loading$ = this._loading.asObservable();
    }
  }
}

